<ul>
  <li *ngFor="let segment of segments" class="category-{{ segment.category }}" [class.active]="segment.value > 0" [class.outside]="segment.isOutside">
    <app-value-bar [value]="segment.value" [min]="segment.min" [max]="segment.max" color="cyan"></app-value-bar>
    <div class="name">
      <span>{{ segment.category | categoryName }}</span>
      <span>{{ segment.value | number:'1.0-1' }} g</span>
    </div>
  </li>
</ul>
